export function logToBrowser(
  message: string,
  loggedToBrowser: boolean
): boolean {
  if (!loggedToBrowser) {
    console.debug(message);
    return true;
  }
  return loggedToBrowser;
}

export function logToJWeb(
  message: string,
  jWeb: any,
  loggedToJWeb: boolean
): boolean {
  if (jWeb && !loggedToJWeb && jWeb?.isNative) {
    jWeb?.Plugins?.Console?.log?.({
      logLevel: 'LOG',
      message
    });
    return true;
  }
  return loggedToJWeb;
}

export function shouldClearInterval(
  loggedToBrowser: boolean,
  loggedToJWeb: boolean,
  startTime: number,
  timeout: number
): boolean {
  const duration = new Date().getTime() - startTime;
  return (loggedToBrowser && loggedToJWeb) || duration > timeout;
}
